import { Box, styled } from 'bonfire-kindling';

const StepConnector = styled(Box)(({ theme }) => ({
  width: '2rem',
  height: '0',
  borderTop: `1px dashed ${theme.palette.grey.light}`,
  margin: `0 ${theme.spacing(2)}`,
}));

export default StepConnector;
